import React, { useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const ReactDatePickerIcon = ({selectedDate, onChange, onFocus, placeholder, setShowOptions}) => {
  // const [selectedDate, setSelectedDate] = useState(null);
  const [open, setOpen] = useState(false);
  const datePickerRef = useRef(null);

  const handleIconClick = () => {
    setShowOptions(false);
    setOpen(true);
  };

  const CustomInput = React.forwardRef(({ value, onFocus, onMouseDown}, ref) => (
  <input
    ref={ref}
    value={value}
    onClick={(e) => e.preventDefault()}
    placeholder={placeholder}
    onFocus={onFocus} 
    onMouseDown={onMouseDown}
    style={{
      width: "100%",
      // padding: "10px 35px 10px 10px",
    }}
  />
));

  return (
    <div style={{ position: "relative", width: "250px" }}>
      <DatePicker
      calendarClassName="workflow-coderview-table-search-date-picker"
        ref={datePickerRef}
        selected={selectedDate}
        onChange={(date) => {
    onChange(date);
    setOpen(false);
  }}
        open={open}
        onClickOutside={() => setOpen(false)}
        onFocus={onFocus}
        onSelect={() => setOpen(false)}
        customInput={<CustomInput />}
      />

      {/* Calendar Icon */}
      <span
        onClick={handleIconClick}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        📅
      </span>
    </div>
  );
};

export default ReactDatePickerIcon;